import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import { Form, 
    Button, Icon, 
    Modal, 
    List, 
    Radio,
    Statistic,
    Row,
    DatePicker,
    Col,
    message} from "antd";
import { Map, OrderedMap } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getValidateStatus
} from "utilities/form";
import CompanyLosService from "./../services/company-los-services";
import moment from "moment";

const FEE_CALCULATION_TYPES = {
    0: "UNDEFINED",
    1: "FIXED",
    2: "PERCENTAGE"
};

const FEE_CALCULATION_LABELS = {
    UNDEFINED: " ",
    FIXED: "₹",
    PERCENTAGE: "%",
};

const getFormFields = () => new OrderedMap({
    id: {
        key: "id",
        label: "Id",
        dataIndex: "id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue",
    },
    lending_partner: {
        key: "lending_partner",
        label: "Partner Bank",
        dataIndex: "lending_partner",
        className: "form-field fb-50",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        getOptionsOnFocus: CompanyLosService.getLendingPartners,
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please select a Partner Bank"
        }]
    },
    charge_at: {
        key: "charge_at",
        label: "Charge At",
        dataIndex: "charge_at",
        className: "form-field fb-50",
        type: INPUT_TYPES.OBJECT_SELECT,
        defaultValue: {id: 2, name: "At First Disbursal"},
        options: [
            {id: 1, name: "At Account Creation"},
            {id: 2, name: "At First Disbursal"},
            {id: 3, name: "Manually"}
        ],
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please select a Charge At"
        }]
    },
});

const START_DATE = "from_date";
const END_DATE = "to_date";

class CompanyFeeForm extends React.Component {
    state = {
        brandIds: new Map({}),
        removedBrands: [],
        addedBrands: false,
        feeMaster: this.props.feeMasterId,
        to_date: this.props.feeMasterId ? this.props.feeData && this.props.feeData.toJS().to_date? moment(this.props.feeData && this.props.feeData.toJS().to_date, "YYYY-MM-DD"):null:moment("31-Dec-9999", "DD-MMM-YYYY"),
        from_date: this.props.feeMasterId ? this.props.feeData && this.props.feeData.toJS().from_date? moment(this.props.feeData && this.props.feeData.toJS().from_date, "YYYY-MM-DD"):null:moment("01-Jan-0001", "DD-MMM-YYYY")
    };

    // componentDidMount() {
    //     if(!this.state.brandIds.size) {
    //         this.toggleFormGrid("ADD");
    //     }
    // }

    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    // getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err && this.state.feeMaster && this.state.from_date && this.state.to_date) {
                    let newValues = values;
                    newValues.charge_at = newValues.charge_at && newValues.charge_at.id;
                    newValues.lending_partner = newValues.lending_partner && newValues.lending_partner.id;
                    newValues.fee_master = this.state.feeMaster;
                    newValues.from_date = this.state.from_date.format("YYYY-MM-DD");
                    newValues.to_date = this.state.to_date.format("YYYY-MM-DD");
                    this.props.onValuesSubmit(newValues);
                }else{
                    message.error("Please enter valid values!");
                }
            });
        }
    }

    getCharge = (type, charge) => {
        if(type === 1){
            return FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]]+charge;
        }else if(type === 2) {
            return charge+FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]];
        }
        return charge;
    }

    handleDateInput = (type, _) => {
        if (
            type === END_DATE &&
            this.state[START_DATE] &&
            this.state[START_DATE].isAfter(_)
        ) {
            return;
        }
        if (
            type === START_DATE &&
            this.state[END_DATE] &&
            this.state[END_DATE].isBefore(_)
        ) {
            return;
        }
        this.setState({
            [type]: _
        });
    };

    renderItem = (_, k) => {
        if(!this.props.update && _.configuration && _.configuration.length === 0){
            return <div/>;
        }
        return (
            <List.Item onClick={() => this.setState({feeMaster: _.id})}  className={"d-flex cursor-pointer align-items-start justify-content-flex-start flex-column"} key={k}>
                <h3>
                    {_.name || _.fee_master.name}
                </h3>
                <div className={"d-flex w-100"}>
                    <Radio 
                        onClick={() => this.setState({feeMaster: _.id})}
                        className={"m-10"}
                        checked={this.state.feeMaster === _.id}
                    />
                    <div className={"w-100 d-flex flex-column"}>
                        {(!this.props.update  ? _.configuration : _.fee_master && _.fee_master.configuration).map((__, key) => 
                            <Row className={"w-100 m-10"} key={key}>
                                <Col span={8}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={"From Limit"}
                                        value={__.from_limit}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={"To Limit"}
                                        value={__.to_limit}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={"Charge"}
                                        value={this.getCharge(__.fee_calculation_type, __.value)}
                                    />
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
            </List.Item>
        );
    }

    disabledDate = (current) => {
        // Disable dates before today (previous dates)
        return current && current < moment().startOf('day');
    }


    render() {
        return (
            <Modal 
                width={800}
                bodyStyle={{
                    paddingRight: "6rem",
                    paddingLeft: "6rem"
                }}
                footer={null}
                title="Add/Update Fee Program"
                visible={this.props.visible}
                onCancel={this.props.toggleModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    {!this.props.update && <>
                        <div className={"form-row align-items-center"}>
                            {this.formFields.map((field, fieldName) => {
                                if (fieldName === "channel_product") {
                                    field.onSearch = this.onSearchProducts;
                                }
                                if (fieldName === "product") {
                                    field.onSearch = CompanyLosService.getProducts;
                                }
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getValidateStatus(fieldName)
                                )();
                            }).toList()}
                        </div>
                        <Row>
                            <Col span={12}>
                                <div className={"displayInline w-100"}>
                                    <p className={"required-field"} style={{ margin: "0px", paddingBottom: "8px" }}>From Date:</p><b />
                                    <div style={{ padding: "10 0 10 0" }}>
                                        <DatePicker
                                            disabledDate={this.disabledDate}
                                            style={{
                                                width: "100% !important"
                                            }}
                                            size={"default"}
                                            className={"mb-5 w-95"}
                                            onChange={this.handleDateInput.bind(
                                                null,
                                                START_DATE
                                            )}
                                            value={this.state.from_date}
                                            required={true}
                                            placeholder={"From Date"}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className={"displayInline w-100"}>
                                    <p className={"required-field"} style={{ margin: "0px", paddingBottom: "8px" }}>To Date:</p><b />
                                    <DatePicker
                                        disabledDate={this.disabledDate}
                                        style={{
                                            width: "100% !important"
                                        }}
                                        size={"default"}
                                        className={"mb-5 w-100"}
                                        onChange={this.handleDateInput.bind(
                                            null,
                                            END_DATE
                                        )}
                                        value={this.state.to_date}
                                        required={true}
                                        placeholder={"To Date"}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </>}
                    <List
                        border={false}
                        className={"border-none"}
                        header={null}
                        bordered
                        footer={null}
                        dataSource={this.props.feeMaster}
                        renderItem={this.renderItem}
                    />
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }
}

CompanyFeeForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.visible,
    toggleModal: PropTypes.func,
    feeMaster: PropTypes.array,
    feeMasterId: PropTypes.string,
    feeData: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value) => {
                            let message = null;
                            if (value === null) {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanyFeeForm);